import React from 'react';
import { CardItem } from '../card-item/CardItem';
import { Box } from '@mui/material';
import styles from './cards.module.scss';
import { wordsResponse } from '../../types';
import { SkeletonList } from '../../../../ui/skeleton/Skeleton';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';

export const CardsList = () => {
  const skeletonArray = Array(10).fill('');
  const { words, loading } = useTypedSelector((state) => state.book);
  const card = words.map((words: wordsResponse, idx) => (
    <CardItem key={words.word} {...{ words, idx }}></CardItem>
  ));
  const skeleton = skeletonArray.map((it, idx) => <SkeletonList key={idx} />);
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <section className={styles.wrapper}> {loading ? skeleton : card}</section>
      </Box>
    </>
  );
};
